import Dispatcher from '../dispatcher';
import resolvePromise from '../helper/resolved_promise';

const TyreActions = {
    updateQtyAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_QTY',
            payload,
        });

        return resolvePromise();
    },
    updateAvailableQuqntitiesAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_QTY_OPTIONS',
            payload,
        });

        return resolvePromise();
    },
    updateTyreImageAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_TYRE_IMAGE',
            payload,
        });

        return resolvePromise();
    },
    updateIdAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_ID',
            payload,
        });

        return resolvePromise();
    },
    updatePriceAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_PRICE',
            payload,
        });

        return resolvePromise();
    },
    updateCurrencyHTMLAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_CURRENCY_HTML',
            payload,
        });

        return resolvePromise();
    },
    updateBrandAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_BRAND',
            payload,
        });

        return resolvePromise();
    },
    updateBrandImageAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_BRAND_IMAGE',
            payload,
        });

        return resolvePromise();
    },
    updateModelAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_MODEL',
            payload,
        });

        return resolvePromise();
    },
    updateSizeAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_SIZE',
            payload,
        });

        return resolvePromise();
    },
    updateBuy4Pay3Action(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_BUY4PAY3',
            payload,
        });

        return resolvePromise();
    },
    updateClearanceAction(payload) {
        "use strict";

        Dispatcher.handleTyreAction({
            type: "UPDATE_CLEARANCE",
            payload
        });

        return resolvePromise();
    },
    update15OffAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_15OFF',
            payload,
        });

        return resolvePromise();
    },
    update100CashbackAction(payload) {
        Dispatcher.handleTyreAction({
            type: "UPDATE_10OCASHBACK",
            payload
        });

        return resolvePromise();
    },
    updateFreefittingAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_FREEFITTING',
            payload,
        });

        return resolvePromise();
    },
    updateAvailabilityAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_AVAILABILITY',
            payload,
        });

        return resolvePromise();
    },
    updateEanAction(payload) {
        Dispatcher.handleTyreAction({
            type: 'UPDATE_EAN',
            payload,
        });

        return resolvePromise();
    },
};

export default TyreActions;
